import React from "react";
import MainRoutes from "./Routes/MainRoutes";
import "bootstrap/dist/css/bootstrap.min.css";

import "./style.css";
function App() {
  return (
    <div>
      <MainRoutes />
    </div>
  );
}

export default App;
